import { type ComponentProps } from 'react';
import { AddressGroupField as ArcAddressGroupField } from '@electricjs/arc';
import { useAddressGroupFieldTranslations } from '@/hooks/useAddressGroupFieldTranslations';

export type { Address } from '@electricjs/arc';
export {
  getRequiredAddressValidationSchema,
  getOptionalAddressValidationSchema,
} from '@electricjs/arc';

type AddressGroupFieldProps = ComponentProps<typeof ArcAddressGroupField>;

const AddressGroupField = (props: AddressGroupFieldProps) => {
  const translations = useAddressGroupFieldTranslations();
  return <ArcAddressGroupField {...translations} {...props} />;
};

export { AddressGroupField };
